"use strict";
import format from "../../formatters/general";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
export default React.createClass({
  propTypes: {
    getSelectedInvoiceForGroup: React.PropTypes.func,
    onFieldChange: React.PropTypes.func,
    sourceInvoiceAmount: React.PropTypes.string,
    sourceInvoiceNumber: React.PropTypes.string
  },
  defaultInvoice: { id: "new" },
  getInitialState: function() {
    return {
      source_invoice_amount: null,
      source_invoice_number: null
    };
  },
  componentDidMount: function() {
    this.setInvoiceFieldsInState(this.props, () => {
      this.props.onFieldChange("source_invoice_amount", this.state.source_invoice_amount);
      this.props.onFieldChange("source_invoice_number", this.state.source_invoice_number);
    });
  },
  componentWillReceiveProps: function(nextProps) {
    if (nextProps.sourceInvoiceAmount !== this.props.sourceInvoiceAmount || nextProps.sourceInvoiceNumber !== this.props.sourceInvoiceNumber) {
      this.setInvoiceFieldsInState(nextProps, () => {
        this.props.onFieldChange("source_invoice_amount", this.state.source_invoice_amount);
        this.props.onFieldChange("source_invoice_number", this.state.source_invoice_number);
      });
    }
  },
  setInvoiceFieldsInState: function(props, callback) {
    const sourceInvoiceAmount = props.sourceInvoiceAmount !== null ? format.cleanAmount(props.sourceInvoiceAmount) : null;
    this.setState({
      source_invoice_amount: sourceInvoiceAmount,
      source_invoice_number: props.sourceInvoiceNumber
    }, callback);
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h4", null, "Verify Invoice Data"), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "medium-5 columns" }, /* @__PURE__ */ React.createElement("label", null, "Invoice Amount"), /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 columns" }, /* @__PURE__ */ React.createElement("span", { className: "prefix" }, "$")), /* @__PURE__ */ React.createElement("div", { className: "small-9 columns" }, this.invoiceInput(
      "source_invoice_amount",
      "Total Charge",
      "text",
      "amount"
    )))), /* @__PURE__ */ React.createElement("div", { className: "medium-5 columns" }, /* @__PURE__ */ React.createElement("label", null, "Invoice Number"), this.invoiceInput(
      "source_invoice_number",
      "Invoice Number",
      "text",
      "number"
    ))));
  },
  invoiceInput: function(field, placeholder, type, ref) {
    return /* @__PURE__ */ React.createElement(
      ValueLinkTextDroppableInput,
      {
        type,
        ref,
        disabled: this.invoiceIsReadOnly(),
        valueLink: this.updateStateAfterInputChange(field),
        placeholder,
        className: "mousetrap-allow-text"
      }
    );
  },
  updateStateAfterInputChange: function(field) {
    const component = this;
    let carrierInvoice = this.carrierInvoice();
    let val;
    if (this.state[field] == null && carrierInvoice[field] != null) {
      val = carrierInvoice[field];
    } else {
      val = this.state[field];
    }
    return {
      value: val,
      requestChange: function(value) {
        let cleanedValue = value;
        if (field === "source_invoice_amount" && !!value) {
          cleanedValue = format.cleanAmount(value);
        }
        const state = {};
        state[field] = value;
        component.setState(state);
        component.props.onFieldChange(field, cleanedValue);
      }
    };
  },
  invoiceIsReadOnly: function() {
    return this.carrierInvoice() && (this.carrierInvoice().state === "approved" || this.carrierInvoice().state === "abandoned");
  },
  carrierInvoice: function() {
    return this.props.getSelectedInvoiceForGroup(this.defaultInvoice);
  },
  focusNextField: function() {
    setTimeout(function() {
      const isReadOnly = this.invoiceIsReadOnly();
      const needsInvoiceAmt = !(this.state.source_invoice_amount || this.carrierInvoice().source_invoice_amount) && !isReadOnly;
      const needsInvoiceNum = !(this.state.source_invoice_number || this.carrierInvoice().source_invoice_number) && !isReadOnly;
      if (needsInvoiceAmt) {
        ReactDOM.findDOMNode(this.refs.amount).focus();
      } else if (needsInvoiceNum) {
        ReactDOM.findDOMNode(this.refs.number).focus();
      } else {
        const firstRadioAssigner = document.querySelector('input[name="carrier-invoice-chooser"]:checked') || document.querySelector('input[name="carrier-invoice-chooser"]');
        if (firstRadioAssigner) {
          firstRadioAssigner.focus();
        }
      }
    }.bind(this));
  }
});
